import WizardWelcome from './component.jsx'
export default WizardWelcome
